import {
  DEFAULT_DATETIME_FORMAT,
  formatDateTimeFromTimestamp
} from "../../../../utils"
import { Activity } from "../../../../../types"

type Props = {
  info: Activity
}

const TimestampCell = ({ info }: Props) => (
  <td className="hidden md:table-cell whitespace-nowrap py-0 pr-2 text-neutral-400 text-right text-sm">
    {formatDateTimeFromTimestamp(info.timestamp, DEFAULT_DATETIME_FORMAT)}
  </td>
)

export default TimestampCell
